export default function SproutFooter() {
  const year = new Date().getFullYear();
  // The releases page is served by journal-dashboard at app.<host>, so from Barnyard we add the
  // prefix the same way journal-dashboard's HeaderNav strips it. Derived, never hard-coded: this
  // renders on RnD, dev and prod, and a literal domain here would send every tier to one of them.
  const releasesUrl = `https://app.${window.location.hostname}/viz/releases.html`;

  return (
    <footer className="w-full bg-primary-hover px-6 py-3 flex items-center justify-between text-xs text-textBody flex-shrink-0">
      <span>&copy; {year} Cargill, Incorporated. All rights reserved.</span>
      <div className="flex items-center gap-4">
        <a
          href={releasesUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
          title="What's landed in dev — generated from git"
        >
          Releases
        </a>
        <a
          href="https://www.cargill.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
        >
          Privacy Policy
        </a>
        <a
          href="https://www.cargill.com/terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors"
        >
          Terms of Use
        </a>
      </div>
    </footer>
  );
}
